import React from "react";
import { Box, Typography, Paper, TextField, Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

const ConfigurationView: React.FC = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Configuration
      </Typography>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Application Settings
        </Typography>
        <Box component="form" sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="API Endpoint"
            defaultValue="https://service.randol.io/runtime-api"
            margin="normal"
          />
          <TextField
            fullWidth
            label="Timeout (seconds)"
            defaultValue="30"
            margin="normal"
            type="number"
          />
          <TextField
            fullWidth
            label="Max Retry Attempts"
            defaultValue="3"
            margin="normal"
            type="number"
          />
          <Box sx={{ mt: 3 }}>
            <Button variant="contained" startIcon={<SaveIcon />}>
              Save Configuration
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ConfigurationView;
